import { BtnGroup, BtnToolbar, Button, ButtonAction, IconTitle, PageTitle } from '@dec/shared';
import * as Icon from 'react-bootstrap-icons';
import { CheckCircleFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { CurrentAccountTaxpayerStatsCard } from '@/app/modules/current-account/components/CurrentAccountTaxpayerStatsCard';
import { TaxReturnCard } from '@/app/modules/tax-returns/components/TaxReturnCard';

export const TaxReturnSurccessPage = () => {
  // se recupera el identificador del pago
  const { id } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const onCancel = () => {
    const url = '/';
    navigate(url);
  };

  return (
    <div>
      <PageTitle
        title={t('taxReturns.taxReturn')}
        subtitle={t('taxReturns.reception')}
        icon={Icon.FileEarmarkText}
      />

      <div className={`alert alert-success fw-bold`}>
        <div className="d-flex justify-content-start gap-4 mt-0">
          <div className="me-4">
            <CheckCircleFill size={45} />
          </div>
          <div>
            <div>
              <h3> {t(`taxReturns.recordSuccess`)}</h3>
            </div>
            <div className="text-muted">{t(`taxReturns.recordSuccessNotes`)}</div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8">
          <TaxReturnCard id={id!} />
        </div>
        <div className="col-12 col-md-4">
          <CurrentAccountTaxpayerStatsCard col={12} />
        </div>
      </div>

      {/* información de pago */}
      <div className="row mt-4">
        <div className="col-12 col-md-6">
          <div className="card">
            <div className="card-header bg-soft text-primary">
              <IconTitle
                title="International bank transfer (SWIFT)"
                icon={Icon.QuestionCircle}
                subtitle="Payment instructions"
              />
            </div>
            <div className="card-body">
              <div>
                The payer is responsible for all bank fees, intermediary bank charges, correspondent
                bank fees and currency conversion costs associated with the transfer.
              </div>
              <div>
                Payment instructions should specify that charges are to be borne by the sender (for
                example, by selecting the SWIFT charging option &quot;OUR&quot;, where available).
                The amount remitted should be sufficient to ensure that the full POSS liability is
                received by PITAA after deduction of any banking fees.
              </div>
              <div>
                Any reduction in the amount received due payment charges or fees does not reduce the
                supplier&apos;s tax liability, and any resulting shortfall remains payable at the
                next reporting period.
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="card">
            <div className="card-header bg-soft text-primary">
              <IconTitle
                title="Credit card payments"
                icon={Icon.QuestionCircle}
                subtitle="Payment instructions"
              />
            </div>
            <div className="card-body">
              <div>
                When paying by credit card, the payer is responsible for any card payment surcharge,
                merchant service fee, foreign transaction fee or currency conversion charge imposed
                by the card issuer, payment processor or financial institution.
              </div>
              <div>
                The payment amount must be sufficient to ensure that the full POSS liability is
                received by PITAA. Any reduction in the amount received due to card-related fees
                does not reduce the supplier&quot;s tax liability, and any resulting shortfall
                remains payable at the next reporting period.
              </div>
            </div>
          </div>
        </div>
      </div>

      <BtnToolbar>
        <BtnGroup>
          {' '}
          <></>{' '}
        </BtnGroup>
        <BtnGroup>
          <Button action={ButtonAction.close} variant="secondary" onClick={onCancel} />
        </BtnGroup>
      </BtnToolbar>
    </div>
  );
};
